import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const tomos = [{
  title: 'CAPÍTULO 1 — SUBÍ DE GRADO SIN ENTRENAR MÁS',
  quote: '“El problema no es cuánto entrenás. Es cómo entrenás.”',
  pages: 'Extensión estimada: 50 páginas',
  chapters: [{
    title: 'Capítulo 1 — Por qué la mayoría se estanca',
    items: ['El falso progreso', 'Escalar mucho ≠ mejorar', 'El error de copiar rutinas de otros', 'Fatiga acumulada invisible', 'El síndrome del “siempre en el mismo grado”']
  }, {
    title: 'Capítulo 2 — Cómo progresa realmente un escalador',
    items: ['Adaptación neuromuscular', 'Técnica vs fuerza', 'Economía de movimiento', 'Eficiencia energética', 'El rol del sistema nervioso']
  }, {
    title: 'Capítulo 3 — Entrenamiento inteligente para subir grados',
    items: ['Volumen útil', 'Intensidad útil', 'Frecuencia ideal', 'Cómo evitar sobreentrenamiento', 'Cómo estructurar una semana']
  }, {
    title: 'Capítulo 4 — Fuerza específica para escalada',
    items: ['Tirón vertical', 'Estabilidad escapular', 'Tensión corporal', 'Core anti-rotacional', 'Transferencia real a roca/muro']
  }, {
    title: 'Capítulo 5 — Técnica que hace subir grados',
    items: ['Lectura de vías', 'Uso de pies', 'Transferencia de peso', 'Timing', 'Descanso en pared', 'Posicionamiento']
  }, {
    title: 'Capítulo 6 — Cómo saber si tu entrenamiento funciona',
    items: ['Indicadores reales', 'Registro de progreso', 'Errores frecuentes', 'Cuándo aumentar dificultad', 'Cuándo bajar carga']
  }, {
    title: 'Capítulo 7 — Sistemas completos por nivel',
    items: ['Principiante', 'Intermedio', 'Avanzado', 'Indoor', 'Boulder', 'Deportiva']
  }]
}, {
  title: 'CAPÍTULO 2 — PREVENCIÓN DE LESIONES EN ESCALADA',
  quote: '“Tu progreso termina el día que se lesionan tus dedos.”',
  pages: 'Extensión estimada: 50 páginas',
  chapters: [{
    title: 'Capítulo 1 — Las lesiones más comunes',
    items: ['Poleas', 'Epicondilitis', 'Hombro', 'Muñeca', 'Lumbricales', 'Tendinitis']
  }, {
    title: 'Capítulo 2 — Por qué los escaladores se lesionan',
    items: ['Exceso de volumen', 'Mala recuperación', 'Mala técnica', 'Mala progresión', 'Ego y sobrecarga']
  }, {
    title: 'Capítulo 3 — Calentamiento específico real',
    items: ['Movilidad útil', 'Activación', 'Progresión de carga', 'Preparación neural']
  }, {
    title: 'Capítulo 4 — Cómo cuidar dedos y poleas',
    items: ['Tipos de agarres', 'Carga segura', 'Cuándo NO entrenar', 'Uso inteligente del hangboard']
  }, {
    title: 'Capítulo 5 — Prevención de hombro y codo',
    items: ['Manguito rotador', 'Escápulas', 'Compensaciones', 'Desequilibrios musculares']
  }, {
    title: 'Capítulo 6 — Recuperación inteligente',
    items: ['Sueño', 'Descargas', 'Deloads', 'Recuperación activa', 'Señales de alarma']
  }, {
    title: 'Capítulo 7 — Protocolos anti-lesión',
    items: ['Rutina pre escalada', 'Rutina post escalada', 'Rutina semanal preventiva', 'Mini sesiones de mantenimiento']
  }]
}, {
  title: 'CAPÍTULO 3 — ESCALADA PARA PRINCIPIANTES',
  quote: '“Dejá de improvisar cada vez que entrás al muro.”',
  pages: 'Extensión estimada: 50 páginas',
  chapters: [{
    title: 'Capítulo 1 — Cómo empezar correctamente',
    items: ['Lo que nadie explica', 'Qué comprar y qué no', 'Indoor vs roca', 'Errores de principiante']
  }, {
    title: 'Capítulo 2 — Técnica básica REAL',
    items: ['Uso de piernas', 'Equilibrio', 'Apoyos', 'Respiración', 'Transferencia']
  }, {
    title: 'Capítulo 3 — Fuerza mínima necesaria',
    items: ['Qué músculos importan', 'Qué NO entrenar', 'Errores de gimnasio']
  }, {
    title: 'Capítulo 4 — Cómo progresar sin frustrarte',
    items: ['Estancamientos normales', 'Miedo a caer', 'Fatiga mental', 'Comparación con otros']
  }, {
    title: 'Capítulo 5 — Entrenamiento semanal simple',
    items: ['2 días', '3 días', '4 días', 'Recuperación']
  }, {
    title: 'Capítulo 6 — Errores que frenan tu progreso',
    items: ['Escalar cansado', 'Copiar avanzados', 'Sobreentrenar dedos', 'Mala técnica']
  }, {
    title: 'Capítulo 7 — Plan de progresión de 12 semanas',
    items: ['Objetivos', 'Cargas', 'Dificultad', 'Recuperación', 'Test de progreso']
  }]
}, {
  title: 'CAPÍTULO 4 — LOS ENTRENAMIENTOS QUE ARRUINAN TU ESCALADA',
  quote: '“Capaz entrenás muchísimo… pero estás destruyendo tu rendimiento.”',
  pages: 'Extensión estimada: 50 páginas',
  chapters: [{
    title: 'Capítulo 1 — El gran problema del escalador amateur',
    items: ['Entrenar demasiado', 'Fatiga invisible', 'El error del gimnasio tradicional']
  }, {
    title: 'Capítulo 2 — Qué entrenamientos interfieren',
    items: ['Hipertrofia excesiva', 'Cardio mal hecho', 'Crossfit sin adaptación', 'Fuerza mal estructurada']
  }, {
    title: 'Capítulo 3 — Cómo detectar interferencia',
    items: ['Falta de fuerza en dedos', 'Fatiga constante', 'Mala recuperación', 'Rigidez', 'Pérdida técnica']
  }, {
    title: 'Capítulo 4 — Qué ejercicios ayudan realmente',
    items: ['Fuerza funcional', 'Core útil', 'Movilidad específica', 'Potencia controlada']
  }, {
    title: 'Capítulo 5 — Cómo combinar gimnasio + escalada',
    items: ['Rutinas compatibles', 'Distribución semanal', 'Volumen ideal', 'Prioridades']
  }, {
    title: 'Capítulo 6 — El error del físico “fitness”',
    items: ['Peso corporal inútil', 'Masa muscular excesiva', 'Relación fuerza/peso']
  }, {
    title: 'Capítulo 7 — Sistemas híbridos inteligentes',
    items: ['Escalada + gym', 'Escalada + running', 'Escalada + calistenia', 'Escalada + funcional']
  }]
}, {
  title: 'CAPÍTULO 5 — NUTRICIÓN PARA ESCALADORES',
  quote: '“No te falta fuerza. Te falta energía útil.”',
  pages: 'Extensión estimada: 50 páginas',
  chapters: [{
    title: 'Capítulo 1 — Nutrición específica para escalada',
    items: ['Rendimiento real', 'Energía sostenida', 'Recuperación']
  }, {
    title: 'Capítulo 2 — El error de comer “fitness”',
    items: ['Dietas extremas', 'Bajo carbohidrato', 'Déficits mal manejados']
  }, {
    title: 'Capítulo 3 — Cómo alimentarte antes de escalar',
    items: ['Timing', 'Energía rápida', 'Digestión']
  }, {
    title: 'Capítulo 4 — Recuperación nutricional',
    items: ['Proteína', 'Carbohidratos', 'Hidratación', 'Electrolitos']
  }, {
    title: 'Capítulo 5 — Peso corporal inteligente',
    items: ['Fuerza/peso', 'Definición útil', 'Rendimiento vs estética']
  }, {
    title: 'Capítulo 6 — Suplementación útil',
    items: ['Creatina', 'Cafeína', 'Magnesio', 'Electrolitos']
  }, {
    title: 'Capítulo 7 — Planes prácticos',
    items: ['Indoor', 'Boulder', 'Deportiva', 'Principiantes', 'Competencia']
  }]
}, {
  title: 'CAPÍTULO 6 — ANTEBRAZOS DE ACERO',
  quote: '“Tu escalada se termina antes que tu técnica.”',
  pages: 'Extensión estimada: 50 páginas',
  chapters: [{
    title: 'Capítulo 1 — Anatomía útil del antebrazo',
    items: ['Flexores', 'Extensores', 'Tendones', 'Fatiga local']
  }, {
    title: 'Capítulo 2 — Por qué se te “queman”',
    items: ['Oclusión', 'Resistencia local', 'Mala respiración', 'Mala eficiencia']
  }, {
    title: 'Capítulo 3 — Fuerza específica de agarre',
    items: ['Crush grip', 'Pinch grip', 'Open hand', 'Half crimp', 'Full crimp']
  }, {
    title: 'Capítulo 4 — Hangboard de verdad',
    items: ['Errores comunes', 'Protocolos reales', 'Volumen', 'Intensidad']
  }, {
    title: 'Capítulo 5 — Resistencia específica',
    items: ['Intervalos', 'Densidad', 'Tiempo bajo tensión']
  }, {
    title: 'Capítulo 6 — Recuperación de antebrazos',
    items: ['Descarga', 'Bombeo', 'Movilidad', 'Descanso neural']
  }, {
    title: 'Capítulo 7 — Protocolos completos',
    items: ['Principiante', 'Intermedio', 'Avanzado', 'Boulder', 'Deportiva']
  }]
}];
export function TomosAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 px-4 max-w-4xl mx-auto" data-id="element-171">
      <h2 className="text-4xl md:text-5xl font-bebas text-center mb-12" data-id="element-172">
        LO QUE VAS A RECIBIR —{' '}
        <span className="text-orange-500" data-id="element-173">6 CAPÍTULOS</span>
      </h2>

      <div className="space-y-4" data-id="element-174">
        {tomos.map((tomo, idx) => {
        const isOpen = openIndex === idx;
        return <div key={idx} className={`bg-card rounded-xl border transition-colors duration-300 overflow-hidden ${isOpen ? 'border-orange-500' : 'border-gray-800'}`} data-id="element-175">
              <button onClick={() => toggleAccordion(idx)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-176">
                <h3 className="text-xl md:text-2xl font-bebas tracking-wide text-white pr-4" data-id="element-177">
                  {tomo.title}
                </h3>
                <motion.div animate={{
              rotate: isOpen ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-178">
                  <ChevronDown className={`w-6 h-6 ${isOpen ? 'text-orange-500' : 'text-gray-400'}`} data-id="element-179" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-180">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-181">
                    <div className="px-6 pb-6 pt-2 border-t border-gray-800/50" data-id="element-182">
                      <div className="mb-6" data-id="element-183">
                        <p className="text-orange-400 italic font-medium mb-1" data-id="element-184">
                          {tomo.quote}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-185">{tomo.pages}</p>
                      </div>

                      <h4 className="font-bold text-lg mb-4 text-white border-b border-gray-800 pb-2" data-id="element-186">
                        Índice
                      </h4>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-187">
                        {tomo.chapters.map((chapter, cIdx) => <div key={cIdx} data-id="element-188">
                            <h5 className="font-semibold text-orange-500 mb-2" data-id="element-189">
                              {chapter.title}
                            </h5>
                            <ul className="space-y-1" data-id="element-190">
                              {chapter.items.map((item, iIdx) => <li key={iIdx} className="text-gray-300 text-sm flex items-start" data-id="element-191">
                                  <span className="text-orange-500 mr-2 mt-0.5" data-id="element-192">
                                    •
                                  </span>
                                  {item}
                                </li>)}
                            </ul>
                          </div>)}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}